import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = {
  class: "add-education",
  "data-testid": "freelancer-signup-completion-education-cta-add"
}
const _hoisted_3 = ["disabled"]

import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {Education} from '@/profile-creation-wizard/components/for-completion/domain/Profile';
    import {useTranslation} from '@malt/vue3-use';
    import {computed, onMounted, ref} from 'vue';
    import {useRouter} from 'vue-router';
    import EducationComponent from './components/Education.vue';
    import YourEducationSide from './YourEducationSide.vue';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import EducationForm from '@/profile-creation-wizard/components/for-completion/ui/your-education/components/EducationForm.vue';
    import {pushVJoySnackbar} from '@maltjoy/core-vue';
    import {EducationResource} from '@/common/api/api-raw-types';
    import Step from '@/profile-creation-wizard/common/ui/step/Step.vue';
    import actions from '@/profile-creation-wizard/store/completion/actions';
    import getters from '@/profile-creation-wizard/store/completion/getters';
    import {useStore} from 'vuex';
    import {inject} from 'vue';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'YourEducationStep',
  setup(__props) {

    const trackingRepository = inject(DI.trackingRepository);
    const store = useStore();
    const router = useRouter();
    const {msg} = useTranslation();

    const meta = computed(() => router.currentRoute.value.meta);

    const refEducationComponent = ref(null);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const educations = computed(() => store.getters[getters.educations]);
    const isStepOptional = computed(() => !store.state.isFunnelStrategy);
    const isNextStepEnabled = computed(() => isStepOptional.value || educations.value.length > 0);
    const isAddingEducationFormOpened = ref(false);

    const editingIndex = ref<number>(null);

    onMounted(async () => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#completion-your-education-bottom-sheet',
            refEducationComponent.value,
            'div.profile-creation-wizard',
        );
    });

    function addEducation() {
        if (editingIndex.value === null) {
            isAddingEducationFormOpened.value = true;
        }
    }

    function cancelAddingEducation() {
        isAddingEducationFormOpened.value = false;
    }

    function cancelEditingEducation() {
        editingIndex.value = null;
    }

    async function goNext() {
        await trackingRepository!.track(`education-input-${meta.value.funnelMode}`, {educations: educations.value.length});
        router.push({name: router.currentRoute.value.meta.nextStep});
    }

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function getNotificationMessage(action, result): string {
        return msg(`profile.creation.completion.wizard.v2.education.${action}.${result}`);
    }

    async function handleAddEducation(education: Education) {
        try {
            isAddingEducationFormOpened.value = false;
            await store.dispatch(actions.updateEducations, [...educations.value, education]);
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('add', 'success'),
                    level: 'error',
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('add', 'error'),
                    level: 'error',
                },
            });
        }
    }

    async function handleEditEducation(education: EducationResource) {
        try {
            const editedEducations = [...educations.value];
            editedEducations[editingIndex.value] = education;

            await store.dispatch(actions.updateEducations, editedEducations);
            editingIndex.value = null;
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('edit', 'success'),
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('edit', 'error'),
                    level: 'error',
                },
            });
        }
    }

    async function handleDeleteEducation(educationEvent: {educationIndex: number}) {
        try {
            const editedEducations = [...educations.value];
            editedEducations.splice(educationEvent.educationIndex, 1);

            await store.dispatch(actions.updateEducations, editedEducations);
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('delete', 'success'),
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: getNotificationMessage('delete', 'error'),
                },
            });
        }
    }

    function setEditingIndex(index: number) {
        editingIndex.value = index === editingIndex.value ? null : index;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Step, {
    "is-step-valid": isNextStepEnabled.value,
    "data-testid": "freelancer-signup-completion-education",
    onGoToNext: goNext
  }, {
    "step-content": _withCtx(() => [
      _createElementVNode("div", {
        ref_key: "refEducationComponent",
        ref: refEducationComponent,
        class: "details-form__item"
      }, [
        _createVNode(StepItemTitle, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.education.title')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_1, [
          _createElementVNode("a", {
            class: "open-bottom-sheet",
            onClick: openBottomSheet
          }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.side.education.title')), 1)
        ])
      ], 512),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("joy-divider-cta", {
          disabled: isAddingEducationFormOpened.value || editingIndex.value != null,
          onClick: addEducation
        }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.education.cta.add')), 9, _hoisted_3),
        (isAddingEducationFormOpened.value)
          ? (_openBlock(), _createBlock(EducationForm, {
              key: 0,
              "onEducationForm:cancel": cancelAddingEducation,
              "onEducationForm:add": handleAddEducation
            }))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(educations.value, (education, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: `education-${index}`
        }, [
          (editingIndex.value === index)
            ? (_openBlock(), _createBlock(EducationForm, {
                key: `education-form-${index}`,
                "education-to-edit": education,
                "data-testid": `education-form-${index}`,
                "onEducationForm:cancel": cancelEditingEducation,
                "onEducationForm:edit": handleEditEducation
              }, null, 8, ["education-to-edit", "data-testid"]))
            : (_openBlock(), _createBlock(EducationComponent, {
                key: `education-component-${index}`,
                education: education,
                "education-index": index,
                "data-testid": `education-component-${index}`,
                "onEducationItem:edit": ($event: any) => (setEditingIndex(index)),
                "onEducationItem:delete": handleDeleteEducation
              }, null, 8, ["education", "education-index", "data-testid", "onEducationItem:edit"]))
        ], 64))
      }), 128))
    ]),
    "step-side": _withCtx(() => [
      _createVNode(YourEducationSide)
    ]),
    _: 1
  }, 8, ["is-step-valid"]))
}
}

})